export const MAP_CONSTANTS = {
    MAP_CENTER: [29.6097547, -95.27213739999999],
    DEFAULT_BOUNDS: [
        [50, -52], //Northeast USA
        [23, -135] //Southwest USA
    ],
    DEFAULT_ZOOM: 5,
    DEFAULT_LAYERS_SETTINGS: {
        NORMAL: {
            ID: 'mapbox/streets-v11', 
            URL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            ATTRIBUTION: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            MAX_ZOOM: 21,
            TILE_SIZE: 512,
            ZOOM_OFFSET: -1
        },
        SATELLITE: {
            ID: 'satellitemap',
            URL: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
            MAX_ZOOM: 21,
            SUB_DOMAINS: ["mt0", "mt1", "mt2", "mt3"]
        }
    },
    //Icons for Filter\Map Items Legend Popup
    //WHERE ARE WE USING THESE vs the above, they look similar
    LEGEND_ICONS: {
        eroc: require('../assets/eroc_icon_valid.svg'),
        cluster: require('../assets/wgmm_ico_map_cluster.svg'),
        home: require('../assets/wgmm_ico_map_interviewer_home.svg'),
        laptop: require('../assets/wgmm_ico_map_gps_laptop.svg'),
        laptopClosest: require('../assets/wgmm_ico_map_gps_laptop_closest.svg'),
        mroc: require('../assets/mroc_icon_valid.svg'),
        phone: require('../assets/wgmm_ico_map_gps_phone.svg'),
        phoneStop: require('../assets/wgmm_ico_map_phone_stop.svg'),
        phoneClosest: require('../assets/wgmm_ico_map_gps_phone_closest.svg'),
        suspect: require('../assets/wgmm_ico_map_suspect.svg'),
        task: require('../assets/wgmm_ico_map_other_address.svg'),
        valid: require('../assets/wgmm_ico_map_valid.svg'),
        validAlternate: require('../assets/wgmm_ico_map_valid_alt.svg'),
        suspectAlternate: require('../assets/wgmm_ico_map_suspect_alt.svg'),
        clientEvent: require('../assets/wgmm_ico_map_gps_client_event.svg'),
        deviceEvent: require('../assets/device.png'),
        locationServiceEvent: require('../assets/locate.png'),
        networkingEvent: require('../assets/wifi.png'),
        powerEvent: require('../assets/battery.png'),
        fatalEvent: require('../assets/fatal5.png'),
    },
    // marker icons
    MARKER_ICONS: {
        foundAddressMarker: {
            iconUrl: require("../assets/wgmm_ico_map_ace_found_address.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        gpsLaptop: {
            iconUrl: require("../assets/wgmm_ico_map_gps_laptop.svg"),
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            popupAnchor: [0, -6],
        },
        gpsLaptopCell: {
            iconUrl: require("../assets/wgmm_ico_map_gps_laptop_cell.svg"),
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            popupAnchor: [0, -6],
        },
        gpsLaptopWifi: {
            iconUrl: require("../assets/wgmm_ico_map_gps_laptop_wifi.svg"),
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            popupAnchor: [0, -6],
        },
        gpsLaptopIp: {
            iconUrl: require("../assets/wgmm_ico_map_gps_laptop_ipaddress.svg"),
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            popupAnchor: [0, -6],
        }, 
        gpsLaptopBadHdop: {
            iconUrl: require("../assets/wgmm_ico_map_gps_laptop_gte_500_hdop.svg"),
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            popupAnchor: [0, -6],
        },                 
        gpsLaptopclosest: {
            iconUrl: require("../assets/wgmm_ico_map_gps_laptop_closest.svg"),
            iconSize: [34, 34],
            iconAnchor: [17, 17],
            popupAnchor: [0, -8],
        },
        gpsPhone: {
            iconUrl: require("../assets/wgmm_ico_map_gps_phone.svg"),
            iconSize: [26, 26],
            iconAnchor: [13, 13],
            popupAnchor: [0, -6],
        },
        gpsPhoneclosest: {
            iconUrl: require("../assets/wgmm_ico_map_gps_phone_closest.svg"),
            iconSize: [34, 34],
            iconAnchor: [17, 17],
            popupAnchor: [0, -8],
        },
        excludedtask: {
            iconUrl: require("../assets/wgmm_ico_map_other_excluded.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        task: {
            iconUrl: require("../assets/wgmm_ico_map_other_address.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        reviewtask: {
            iconUrl: require("../assets/wgmm_ico_map_in_review.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        validtask: {
            iconUrl: require("../assets/wgmm_ico_map_valid.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        validtaskeroc: {
            iconUrl: require("../assets/eroc_icon_valid.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        validtaskmroc: {
            iconUrl: require("../assets/mroc_icon_valid.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        nolocationtask: {
            iconUrl: require("../assets/wgmm_ico_location.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        suspecttask: {
            iconUrl: require("../assets/wgmm_ico_map_suspect.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 50],
            popupAnchor: [0, -45],
        },
        cluster: {
            iconUrl: require("../assets/wgmm_ico_map_cluster.svg"),
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [0, -20],
        },
        stop: {
            iconUrl: require("../assets/wgmm_ico_map_phone_stop.svg"),
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [0, -20],
        },
        staffAddress: {
            iconUrl: require("../assets/wgmm_ico_map_interviewer_home.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        markerLocation: {
            iconUrl: require("../assets/wgmm_ico_location_active.svg"),
            iconSize: [32, 32],
            iconAnchor: [17, 29],
            popupAnchor: [0, -16],
        },
        addressMarker: {
            iconUrl: require("../assets/wgmm_ico_map_address.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        altaddress: {
            iconUrl: require("../assets/wgmm_ico_otheraddress.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        validAlt: { // Valid Alternate Address
            iconUrl: require("../assets/wgmm_ico_map_valid_alt.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        suspectAlt: { // Suspect Alternate Address
            iconUrl: require("../assets/wgmm_ico_map_suspect_alt.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        }, 
        noData: {
            iconUrl: require("../assets/wgmm_ico_map_no_data.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        noDataAlt: {
            iconUrl: require("../assets/wgmm_ico_map_no_data_alt.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },               
        laptop: require("../assets/wgmm_ico_map_laptop.svg"),
        phone: require("../assets/wgmm_ico_map_phone.svg"),
        disabledLaptop: require("../assets/wgmm_ico_map_laptop_disabled.svg"),
        disabledPhone: require("../assets/wgmm_ico_map_phone_disabled.svg"),
        clientEvent: {
            iconUrl: require("../assets/bolt.svg"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        deviceEvent: {
            iconUrl: require("../assets/device.png"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        locationServiceEvent: {
            iconUrl: require("../assets/locate.png"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        networkingEvent: {
            iconUrl: require("../assets/wifi.png"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        powerEvent: {
            iconUrl: require("../assets/battery.png"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        },
        fatalEvent: {
            iconUrl: require("../assets/fatal5.png"),
            iconSize: [50, 50],
            iconAnchor: [25, 25],
            popupAnchor: [0, -20],
        }
    },
    TRACK_STYLES: {
        laptopDefaultStyle: {
            color: '#0089f7',
            opacity: 1,
            weight: 2,
            fillOpacity: 1,
        },
        laptopHighlightStyle: {
            color: '#6800b3',
            opacity:1,
            weight: 3,
            fillOpacity: 1,
        },
        phoneDefaultStyle: {
            color: '#e77504',
            opacity: 1,
            weight: 2,
            fillOpacity: 1,
        },
        phoneHighlightStyle: {
            color: '#6800b3',
            opacity:1,
            weight: 3,
            fillOpacity: 1,
        }
    },
    CASE_ASSIGN_MAP_MARKERS: {
        STAFF_HOME: 'staff',
        UNASSIGNED: '11_10_0',
        UNASSIGNED_HIGH_PRIORITY: '11_10_1',
        NOT_REVIEWED: '11_20_0',
        NOT_REVIEWED_HIGH_PRIORITY: '11_20_1',
        CONFIRMED: '11_30_0',
        CONFIRMED_HIGH_PRIORITY: '11_30_1',
        ASSIGNED: '11_40_0',
        ASSIGNED_HIGH_PRIORITY: '11_40_1',
		SCREEN_UNASSIGNED: '11.1_10_0',
        SCREEN_UNASSIGNED_HIGH_PRIORITY: '11.1_10_1',
        SCREEN_NOT_REVIEWED: '11.1_20_0',
        SCREEN_NOT_REVIEWED_HIGH_PRIORITY: '11.1_20_1',
        SCREEN_CONFIRMED: '11.1_30_0',
        SCREEN_CONFIRMED_HIGH_PRIORITY: '11.1_30_1',
        SCREEN_ASSIGNED: '11.1_40_0',
        SCREEN_ASSIGNED_HIGH_PRIORITY: '11.1_40_1'
    },
    CASE_ASSIGN_MAP_MARKER_ICONS: {
        staff: {
            icon: require("../assets/wgmm_ico_map_interviewer_home.svg"),
        },
        caseNotReviewed: {
            icon: require("../assets/wgmm_ico_map_ace_found_address.svg"),
        },
        caseConfirmed: {
            icon: require("../assets/wgmm_ico_map_ace_valid_address.svg"),
        },
        caseProposed: {
            icon: require("../assets/wgmm_ico_map_ace_added_suspect.svg"),
        },
        caseSuspense: {
            icon: require("../assets/wgmm_ico_map_ace_suspect_address.svg"),
        },
        caseTransfer: {
            icon: require("../assets/wgmm_ico_map_ace_added_valid.svg"),
        },
        caseUnassigned: {
            icon: require("../assets/wgmm_ico_location.svg"),
        },
        priorityHigh: {
            icon: require("../assets/wgmm_ico_map_ace_added_suspect.svg"),
        },
        // 6 new icons
        '11_10_0': {
            icon: require("../assets/wgmm_ico_map_ace_suspect_address.svg"), // red house
        },
        '11_20_0': {
            icon: require("../assets/wgmm_ico_map_ace_found_address.svg"), // grey house
        },
        '11_30_0': {
            icon: require("../assets/wgmm_ico_map_ace_valid_address.svg"), // greenhouse
        },
        '11_40_0': {
            icon: require("../assets/case_assigned_normal.svg"), // bluehouse
        },
        '11_10_1': {
            icon: require("../assets/wgmm_ico_map_ace_added_suspect.svg"), // red house with +
        },
        '11_20_1': {
            icon: require("../assets/wgmm_ico_map_ace_found_address_added.png") // grey house with +
        },
        '11_30_1': {
            icon: require("../assets/wgmm_ico_map_ace_added_valid.svg"), // green house with +
        },
        '11_40_1': {
            icon: require("../assets/case_assigned_priority.svg"), // blue house with +
        },        
        // 6 new Screener Icons
        '11.1_10_0': {
            icon: require("../assets/screener_unassigned_normal.svg") // red screener
        },
        '11.1_20_0': {
            icon: require("../assets/screener_notreviewed_normal.svg") // grey screener
        },
        '11.1_30_0': {
            icon: require("../assets/screener_confirmed_normal.svg") // green screener
        },
        '11.1_40_0': {
            icon: require("../assets/screener_assigned_normal.svg") // blue screener
        },
        '11.1_10_1': {
            icon: require("../assets/screener_unassigned_priority.svg") // red screener with +
        },
        '11.1_20_1': {
            icon: require("../assets/screener_notreviewed_priority.svg") // grey screener with +
        },
        '11.1_30_1': {
            icon: require("../assets/screener_confirmed_priority.svg") // green screener with +
        },
        '11.1_40_1': {
            icon: require("../assets/screener_assigned_priority.svg") // blue screener with +
        }
				// red #e31a1c;
				// green #6ba23e
				// grey #939393
                // blue #00107F
    },
    POLYGON_STYLES: {
        HIGHLIGHTED: {
            fillColor: "#2c7589",
            fillOpacity: .75,
            weight: 2,
            opacity: 1,
            color: "darkgrey",
            riseOffset: 500,
            zIndex: 299
          },
        DEFAULT: {
            fillColor: "lightgrey",
            fillOpacity: 0.5,
            weight: 2,
            opacity: 1,
            color: "lightgrey",
            dashArray: "3",
            zIndex: 300
          }
    },
    CASE_ASSIGN_MARKER_TYPES: {
        UNASSIGNED: 1,
        NOT_REVIEWED: 2,
        CONFIRMED: 3,
        ASSIGNED: 4,
        UNASSIGNED_HIGH_PRIORITY: 5,
        NOT_REVIEWED_HIGH_PRIORITY: 6,
        CONFIRMED_HIGH_PRIORITY: 7,
        ASSIGNED_HIGH_PRIORITY: 8,
        SCREENER_UNASSIGNED: 9,
        SCREENER_NOT_REVIEWED: 10,
        SCREENER_CONFIRMED: 11,
        SCREENER_ASSIGNED: 12,
        SCREENER_UNASSIGNED_HIGH_PRIORITY: 13,
        SCREENER_NOT_REVIEWED_HIGH_PRIORITY: 14,
        SCREENER_CONFIRMED_HIGH_PRIORITY: 15,
        SCREENER_ASSIGNED_HIGH_PRIORITY: 16,
    },
    CASE_ASSIGN_FILTER_TYPES: {
        SHOW_ALL: 0,
        SHOW_SCREENER: 1,
        SHOW_NON_SCREENER: 2
    },
    CASE_ASSIGN_GENERIC_STAFF_ID: {
        UNASSIGNED: 'Unassigned',
    },
    CASE_ASSIGN_Z_INDEX: {
        DEEP: 500,
        SHALLOW: 100
    },
    MAP_MUTATION_TYPES: {
        TASK: 0,
        GPS: 1,
        CLUSTER: 2 
    },
    MAP_EVENT_TYPES: {
        LOADER: 0,
        GET_TASK_TRACK: 1,
        CLOSEST_CLUSTER: 2,
        CLOSEST_POINT: 3
    },
    VALIDATION_MARKER_TYPES: {
        STAFF_HOME: 'home',
        TASKS: 'tasks',
        EROC_TASKS: 'erocTasks',
        LAPTOP_GPS_POINTS: 'laptopGpsPoints',
        LAPTOP_CLOSEST_GPS_POINTS: 'laptopClosestGpsPoint',
        CLUSTERS: 'clusters',
        LAPTOP_TRAVEL_LINES: 'laptopTravelLines',
        VALID_TASKS: 'validTasks',
        SUSPECT_TASKS: 'suspectTasks',
        MROC_TASKS: 'mrocTasks',
        PHONE_GPS_POINTS: 'phoneGpsPoints',
        PHONE_CLOSEST_GPS_POINTS: 'phoneClosestGpsPoint',
        STOP_POINTS: 'stopPoints',
        PHONE_TRAVEL_LINES: 'phoneTravelLines'
    },
    ASSIGNMENT_POPUP_TASK_IMG: require("../assets/bubble.png"),
    ASSIGNMENT_MAP_MARKER_OPAQUES: {
        SHOW: 1,
        BARELY_SHOW: .4
    }
};
